import { Observable, catchError, tap, throwError } from 'rxjs';

import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { AppError } from '@cxc/core/models';

import { ErrorStore } from '@cxc/core/services';

import { RETRIED_ON_401 } from './http-authorization.interceptor';

export function httpErrorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  const errorStore = inject(ErrorStore);

  return next(req).pipe(
    tap({
      complete: () => {
        const isNotificationUpdate = req.url.includes(
          '/api/v1/notify/notifications/unread-count'
        );

        // Ignore the check made every 60 seconds for unread notifications.
        // This is temporary until we get the websocket implementation.
        if (!isNotificationUpdate) {
          errorStore.clear();
        }
      },
    }),
    // A 401 is not a logout here (LEN-2764): the authorization interceptor
    // refreshes the token and retries, and logs out only if that fails.
    catchError((error: AppError) => {
      // The authorization interceptor (outside this one) marks the requests whose
      // 401 it refreshes and retries; storing that 401 would latch an error for a
      // request that then succeeds.
      const willBeRetried =
        (error as { status?: number }).status === 401 &&
        req.context.get(RETRIED_ON_401);
      if (!willBeRetried) {
        errorStore.error.set(error);
      }
      return throwError(() => error);
    })
  );
}
